function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Icons/Browse");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("rect", {
  id: "path-1",
  x: 0,
  y: 0,
  width: 16,
  height: 16
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "All-Screens",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Home---1820x1024",
  transform: "translate(-274.000000, -45.000000)"
}, React.createElement("g", {
  id: "Header---1820",
  transform: "translate(272.000000, 0.000000)"
}, React.createElement("g", {
  id: "Search",
  transform: "translate(0.000000, 41.000000)"
}, React.createElement("g", {
  id: "Icons/Browse",
  transform: "translate(0.000000, 2.000000)"
}, React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#path-1"
})), React.createElement("g", {
  id: "Background"
}), React.createElement("g", {
  id: "noun_Search_875352",
  strokeWidth: 1,
  fillRule: "evenodd",
  mask: "url(#mask-2)",
  fill: "#BBBEBF"
}, React.createElement("g", {
  transform: "translate(2.000000, 2.000000)",
  id: "Shape"
}, React.createElement("path", {
  d: "M11.8008605,10.8648649 L9.64720344,8.72727273 C11.3288261,6.57493857 11.1518132,3.50859951 9.21942225,1.57739558 C8.20159803,0.56019656 6.84449908,0 5.39889367,0 C3.95328826,0 2.59618931,0.56019656 1.57836509,1.57739558 C0.560540873,2.59459459 0,3.95085995 0,5.3955774 C0,6.84029484 0.560540873,8.1965602 1.57836509,9.21375921 C2.59618931,10.2309582 3.95328826,10.7911548 5.39889367,10.7911548 C6.59373079,10.7911548 7.77381684,10.3931204 8.71788568,9.64127764 L10.8567916,11.8083538 C10.9895513,11.9410319 11.1518132,12 11.3288261,12 C11.505839,12 11.6681008,11.9262899 11.8008605,11.8083538 C12.0663798,11.5577396 12.0663798,11.1302211 11.8008605,10.8648649 Z M9.47019053,5.3955774 C9.47019053,6.48648649 9.04240934,7.5036855 8.27535341,8.27027027 C7.50829748,9.03685504 6.47572219,9.46437346 5.39889367,9.46437346 C4.32206515,9.46437346 3.28948986,9.03685504 2.52243393,8.27027027 C1.755378,7.5036855 1.3275968,6.47174447 1.3275968,5.3955774 C1.3275968,4.3046683 1.755378,3.28746929 2.52243393,2.52088452 C3.28948986,1.75429975 4.32206515,1.32678133 5.39889367,1.32678133 C6.49047326,1.32678133 7.50829748,1.75429975 8.27535341,2.52088452 C9.04240934,3.28746929 9.47019053,4.3046683 9.47019053,5.3955774 Z"
}))))))));

var SvgBrowse = function SvgBrowse(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    ref: svgRef
  }, props), title === undefined ? _ref2 : React.createElement("title", null, title), _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBrowse, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/browse.e7fa128a.svg";
export { ForwardRef as ReactComponent };